<template>
  <div class="container top">
    <div>
      <img src="@/assets/images/mall/mall_01.png" class="mallImage" />
      <img src="@/assets/images/mall/mall_02.png" class="mallImage" />
    </div>
    <a href="https://www.thepinx.co.kr/" target="_blank">
      <img src="@/assets/images/mall/mall_06.png" class="mallImage my-4" />
    </a>
    <div style="display: flex">
      <!-- 로멘틱허니문 PKG -->
      <div>
        <!--        <a href="https://devel-podo.thepinx.co.kr/p/ItemDetail/33/110288?member=1">-->
        <a href="https://podo.thepinx.co.kr/p/ItemDetail/33/110327?member=1" target="_blank">
          <img src="@/assets/images/mall/mall_03.png" class="mallImage" />
        </a>
      </div>
      <!-- 사랑해효3박 PKG -->
      <div>
        <!--        <a href="https://devel-theannex.thepinx.co.kr/p/ItemDetail/34/110289?member=1">-->
        <a href="https://theannex.thepinx.co.kr/p/ItemDetail/34/110328?member=1" target="_blank">
          <img src="@/assets/images/mall/mall_04.png" class="mallImage" />
        </a>
      </div>
    </div>
    <!--    <a href="/p/MemberReserv">-->
    <!--      <img src="@/assets/images/mall/mall_05.png" class="mallImage" />-->
    <!--    </a>-->
  </div>
</template>

<script>
export default {
  name: 'mall.vue',
};
</script>

<style scoped lang="scss">
.mallImage {
  width: 100%;
}
@media (max-width: 992px) {
  //.top {
  //  padding-top: 5rem;
  //}
}
@media (min-width: 992px) {
  //.top {
  //  padding-top: 11rem;
  //}
}
</style>
